class MainProduct extends HTMLElement {
  constructor() {
    super();

    this.variantTitle = this.querySelector(".product__variant-title");
    this.quantityLabel1 = this.querySelector(".js-product-form__quantity1");
    this.quantityLabel2 = this.querySelector(".js-product-form__quantity2");
    this.quantityLabel3 = this.querySelector(".js-product-form__quantity3");

    this.buyxGetyDefaultVariants = this.querySelector(
      ".buyx-gety__default-variants",
    );

    this.quantityLabels = this.querySelectorAll(".buyx-gety__label");
    this.quantityLabelDefault = this.querySelector(".buyx-gety__label-default");

    this.productStockBlock = this.querySelector(".product__stock");

    this.variantInputs = this.querySelectorAll(
      'input[type="radio"][name="id"]',
    );
    this.quantityInputs = this.querySelectorAll(
      'input[type="radio"][name="quantity"]',
    );

    this.dropdowns = this.querySelectorAll(".buyx-gety__dropdown");
    this.imageOpeners = this.querySelectorAll(
      ".buyx-gety__dropdown-image-wrapper",
    );

    this.buyxGety = this.querySelector(".buyx-gety");
    this.buyxGetySubmit = this.querySelector(".buyx-gety__submit");

    this.buyXgetYLabelChange();

    this.bundleInputs = document.querySelectorAll('input[name="bundle_items"]');
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.variantInputs.forEach((input) =>
      input.addEventListener("change", this.handleVariantChange.bind(this)),
    );

    this.quantityInputs.forEach((input) =>
      input.addEventListener("change", this.handleQuantityChange.bind(this)),
    );

    if (this.buyxGety) {
      this.setupDropdowns();
      this.imageOpener();
      this.handleBuyxGetySubmit();
      this.buyXgetYLabelDefaultChange();
      this.buyxgetyDefaultVariantsChange();
      this.sortDropdownItems();
    }

    if (this.bundleInputs?.length) {
      this.handleBundlesInputs();
      this.handleInsideBundleVariantChange();
    }
  }

  handleVariantMediaChange(button) {
    this.renderGalleryMedia(
      button.dataset.media,
      button.dataset.mediaType,
      button.dataset.poster,
    );
  }

  updateGallerySlider(mediaJson) {
    const sliderNode = document.querySelector('.product__slider.embla');
    if (!sliderNode) return;

    let media;
    try { media = JSON.parse(mediaJson); } catch (e) { return; }
    if (!Array.isArray(media) || !media.length) return;

    const container = sliderNode.querySelector('.embla__container');
    const thumbsContainer = sliderNode.querySelector('.embla-thumbs__container');

    if (container) {
      container.innerHTML = media.map((item) => {
        if (item.type === 'video') {
          return `<div class="embla__slide product__slide product__slide-video">
            <video autoplay muted playsinline poster="${item.poster}">
              <source src="${item.src}" type="video/mp4">
            </video>
          </div>`;
        }
        return `<div class="embla__slide product__slide product__slide-img">
          <img src="${item.src}" alt="${item.alt || ''}">
        </div>`;
      }).join('');
    }

    if (thumbsContainer) {
      thumbsContainer.innerHTML = media.map((item, index) => {
        const selected = index === 0 ? ' embla-thumbs__slide--selected' : '';
        return `<div class="embla-thumbs__slide${selected}">
          <img src="${item.thumb}" loading="lazy" alt="${item.alt || ''}">
        </div>`;
      }).join('');
    }

    const oldApi = sliderNode._emblaApi;
    const oldThumbs = sliderNode._emblaThumbs;
    if (oldApi) oldApi.destroy();
    if (oldThumbs) oldThumbs.destroy();
    if (window.initEmblaCarousel) window.initEmblaCarousel(sliderNode);

    if (container) {
      container.querySelectorAll('video').forEach((v) => v.play().catch(() => {}));
    }
  }

  // Liquid renders the single-media gallery as EITHER an <img> wrapper
  // (.product__one-image-img) or a <video> wrapper (.product__one-image-video),
  // decided once from the landed variant's video metafield. Switching to a
  // product/variant of the other media type therefore has to replace the
  // element and retag the wrapper - assigning a .mp4 to an existing <img>.src
  // (or blanking a <video>.src to show a poster) just breaks the gallery.
  // Note the selector deliberately skips the slider's .product__one-image
  // container, which carries neither tag class and is handled by
  // updateGallerySlider instead.
  renderGalleryMedia(url, type, poster) {
    if (!url) return;

    const wrapper = document.querySelector(
      ".product__one-image-img, .product__one-image-video",
    );
    if (!wrapper) return;

    const isVideo = type === "video";
    const current = wrapper.querySelector("video, img");

    wrapper.classList.toggle("product__one-image-video", isVideo);
    wrapper.classList.toggle("product__one-image-img", !isVideo);

    if (isVideo) {
      // Always drive the src attribute rather than the <source> children:
      // video_tag emits one <source> per format, and a src attribute overrides
      // all of them, so no stale source can win resource selection. It also
      // avoids declaring a type for a metafield file that may not be mp4.
      if (current && current.tagName === "VIDEO") {
        if (poster) current.poster = poster;
        current.src = url;
        current.load();
        current.play().catch(() => {});
        return;
      }

      const video = document.createElement("video");
      video.autoplay = true;
      video.muted = true;
      // Safari only honours inline autoplay when muted is a real attribute
      video.setAttribute("muted", "");
      video.playsInline = true;
      if (poster) video.poster = poster;
      video.src = url;

      if (current) current.replaceWith(video);
      else wrapper.appendChild(video);

      video.play().catch(() => {});
      return;
    }

    if (current && current.tagName === "IMG") {
      current.src = url;
      current.srcset = "";
      return;
    }

    const img = document.createElement("img");
    img.src = url;
    img.alt = "";

    if (current) current.replaceWith(img);
    else wrapper.appendChild(img);
  }

  handleBundlesInputs() {
    let bundleId = this.querySelector('input[type="hidden"][name="id"]');

    this.bundleInputs.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        const variantId = event.target.dataset.variant;
        const variantTitle = event.target.dataset.title;
        const stock = event.target.dataset.stock;
        const img = event.target.dataset.img;

        this.renderGalleryMedia(img, "image");

        bundleId.value = variantId;

        if (variantTitle) {
          this.variantTitle.textContent = variantTitle;
        }
        this.handleStockAmount(stock);
        this.updateURLWithVariant(variantId);

        // Change labels colors
        this.bundleInputs.forEach((input) => {
          const parent = input.closest(".product-form__bundle-item");
          const labels = parent.querySelector(".product-form__labels");

          if (labels) {
            labels.querySelectorAll("div").forEach((badge) => {
              badge.style.backgroundColor = "var(--body-base)";
              badge.style.color = "var(--neutral-1000)";
            });
          }
        });
        const parent = event.target.closest(".product-form__bundle-item");
        const labels = parent.querySelector(".product-form__labels");
        if (labels) {
          labels.querySelectorAll("div").forEach((badge) => {
            let border = badge.dataset.border;
            let back = badge.dataset.back;

            badge.style.backgroundColor = back;
            badge.style.border = "1px solid " + border;
            badge.style.color = "#fff";
          });
        }
      });
    });
  }

  handleInsideBundleVariantChange() {
    const submitInputs = document.querySelectorAll(".bundleVariantsInput");

    document.addEventListener("click", (e) => {
      const itemEl = e.target.closest(".bundle__product-variant");
      if (!itemEl) return;

      const wrapper = itemEl.closest(".product-form__bundle-products");
      if (!wrapper) return;

      this.imageOpeners.forEach((wrapper) => {
        wrapper.classList.remove("active");
      });

      const thisBundleProduct = itemEl.closest(".budnle__product");
      thisBundleProduct
        .querySelectorAll(".bundle__product-variant")
        .forEach((v) => v.classList.remove("bundle__product-variant-selected"));

      itemEl.classList.add("bundle__product-variant-selected");

      const index = wrapper.dataset.variantIndex;
      if (index != null && submitInputs[index]) {
        submitInputs[index].value =
          submitInputs[index].value + " " + itemEl.dataset.variant;
      }
    });
  }

  buyXgetYLabelDefaultChange() {
    if (this.quantityLabelDefault) {
      this.quantityLabelDefault.addEventListener("click", () => {
        this.imageOpeners.forEach((wrapper) => {
        wrapper.classList.remove("active");
      });
      
        if (this.quantityLabelDefault.dataset.available == "true") {
          this.buyxGetySubmit.disabled = false;
        } else {
          this.buyxGetySubmit.disabled = true;
        }
      });
    }
  }

  buyxgetyDefaultVariantsChange() {
    if (this.buyxGetyDefaultVariants) {
      const buttons = this.buyxGetyDefaultVariants.querySelectorAll("button");

      if (!buttons) return;

      buttons.forEach((btn) => {
        btn.addEventListener("click", (e) => {          
          e.preventDefault();
          e.stopPropagation();
          this.imageOpeners.forEach((wrapper) => {
            wrapper.classList.remove("active");
          });

          this.handleVariantMediaChange(btn);

          if(this.variantTitle) {
            this.variantTitle.textContent = btn.dataset.title;          
          }

          const btnStyle = btn.dataset.style;

          if (btnStyle == "green") {
            buttons.forEach((b) => {
              b.classList.remove("g-btn--fill-tertiary-green");
              b.classList.add("g-btn--outline-tertiary-green");
            });
            btn.classList.add("g-btn--fill-tertiary-green");
            btn.classList.remove("g-btn--outline-tertiary-green");
          } else if (btnStyle == "purple") {
            buttons.forEach((b) => {
              b.classList.remove("g-btn--fill-secondary");
              b.classList.add("g-btn--outline-secondary");
            });
            btn.classList.add("g-btn--fill-secondary");
            btn.classList.remove("g-btn--outline-secondary");
          }

          const selectedValue = btn.dataset.value;
          const price = btn.dataset.price;
          const compareAtPrice = btn.dataset.compareAtPrice; 

          let priceWrapper =
            this.buyxGetyDefaultVariants.parentElement.querySelector(
              ".default-price",
            );

          if(compareAtPrice) {
            priceWrapper.innerHTML = `<span class="plan-price body-bold price__sale">${price}</span><span class="original-price body">${compareAtPrice}</span>`;
          } else {
            priceWrapper.innerHTML = `<span class="plan-price body-bold">${price}</span>`;
          }

          const parentLabel = this.buyxGetyDefaultVariants.closest("label");
          const hiddenInput = parentLabel?.querySelector("input");
          if (hiddenInput) {
            hiddenInput.value = btn.dataset.value;
          }
          this.updateTotals();
        });
      });
    }
  }

  buyXgetYLabelChange() {
    if (this.quantityLabels) {
      this.quantityLabels.forEach((label) => {
        label.addEventListener("click", () => {
          this.imageOpeners.forEach((wrapper) => {
        wrapper.classList.remove("active");
      });

          let allDropdownsInLabel = Array.from(
            label.querySelectorAll(".buyx-gety__dropdown"),
          );
          if (allDropdownsInLabel) {
            this.checkAvailabilities(allDropdownsInLabel);
          }

          if (!label.classList.contains("buyx-gety__label-default-oos")) {
            this.quantityLabels.forEach((label) => {
              label.classList.remove("buyx-gety__dropdown-variants-visible");

              let currentLabelBadgesDiv = label.querySelector(
                ".product-form__labels",
              );

              if (currentLabelBadgesDiv) {
                let currentBadgesDivs =
                  currentLabelBadgesDiv.querySelectorAll("div");

                currentBadgesDivs.forEach((badge) => {
                  badge.style.backgroundColor = "var(--body-base)";
                });
              }
            });

            let clickedLabelBadgesDiv = label.querySelector(
              ".product-form__labels",
            );
            label.classList.add("buyx-gety__dropdown-variants-visible");

            if (clickedLabelBadgesDiv) {
              clickedLabelBadgesDiv.querySelectorAll("div").forEach((badge) => {
                let border = badge.dataset.border;
                let back = badge.dataset.back;
                badge.style.backgroundColor = back;
                badge.style.border = "1px solid " + border;
              });
            }
          }
        });
      });
    }
  }

  handleBuyxGetySubmit() {
    if (!this.buyxGetySubmit) return;

    this.buyxGetySubmit.addEventListener("click", async (e) => {
      e.preventDefault();

      if (this.addingToCartProcess) return;
      this.addingToCartProcess = true;

      const selectedInput = this.querySelector(
        'input[name="selected_products[]"]:checked',
      );
      if (!selectedInput) {
        console.warn("No products selected");
        return;
      }

      const ids = selectedInput.value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);

      const counts = ids.reduce((acc, id) => {
        acc[id] = (acc[id] || 0) + 1;
        return acc;
      }, {});

      const items = Object.entries(counts).map(([id, quantity]) => ({
        id: Number(id),
        quantity,
      }));

      try {
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });
        const added = await res.json();
        await window.updateCartDrawer();
        // window.openCartDrawer();
        const formData = new FormData();
        items.forEach((item, i) => {
          formData.append(`items[${i}][id]`, item.id);
          formData.append(`items[${i}][quantity]`, item.quantity);
        });
        const qtyJustAdded = window.getAddedQuantityFromFormData(formData); // ← 1, or sum of items[n][quantity]

        // 4) Fill cart-notification
        window.fillCartNotification(added?.items, qtyJustAdded);

        // 5) Show notification (your existing function)
        window.openCartNotification();
      } catch (err) {
        console.error("Error adding to cart:", err);
      } finally {
        this.addingToCartProcess = false;
      }
    });
  }

  updateURLWithVariant(variantId) {
    const url = new URL(window.location);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url);
  }

  imageOpener() {
    if (this.imageOpeners) {
      this.imageOpeners.forEach((wrapper) =>
        wrapper.addEventListener("click", (e) => {
          if (window.innerWidth >= 768) return;

          e.preventDefault();
          e.stopPropagation();

          this.imageOpeners.forEach((opener) => {
            opener.classList.remove("active");
          });

          wrapper.classList.toggle("active");
        }),
      );
    }
  }

  setupDropdowns() {
    const dropdowns = this.querySelectorAll(".buyx-gety__dropdown");
    // The product-switcher <li> list is rendered once in the DOM (see
    // #buyx-gety__shared-options in buyx-gety.liquid) and physically moved into
    // whichever dropdown is currently open, instead of being duplicated per unit.
    // This relies on only one .buyx-gety__dropdown ever being open at a time.
    const sharedList = this.querySelector("#buyx-gety__shared-options");

    dropdowns.forEach((dropdown) => {
      const button = dropdown.querySelector(".buyx-gety__dropdown-button");
      const list = dropdown.querySelector(".buyx-gety__dropdown-list");
      const group = dropdown.querySelector(".buyx-gety__dropdown-variants");

      if (!button) return;

      button.addEventListener("click", (e) => {
        e.stopPropagation();

        this.imageOpeners.forEach((wrapper) => {
        wrapper.classList.remove("active");
      });

        dropdowns.forEach((d) => {
          if (d !== dropdown) d.classList.remove("open");
        });

        if (sharedList && list) {
          list.appendChild(sharedList);
          sharedList.hidden = false;

          const currentValue = dropdown.dataset.selectedValue;
          sharedList.querySelectorAll(".buyx-gety__dropdown-item").forEach((el) => {
            el.classList.toggle(
              "dropdown-svg__visible",
              el.dataset.value === currentValue,
            );
          });
        }

        dropdown.classList.toggle("open");
      });

      const buttons = Array.from(group.querySelectorAll("button[data-value]"));
      this.handleBuyxGetyVariantChange(buttons, group, dropdown);
    });

    if (sharedList) {
      sharedList.addEventListener("click", (e) => {
        const item = e.target.closest(".buyx-gety__dropdown-item");
        if (!item) return;

        const dropdown = item.closest(".buyx-gety__dropdown");
        if (!dropdown) return;

        const label = dropdown.querySelector(".buyx-gety__dropdown-label");
        const group = dropdown.querySelector(".buyx-gety__dropdown-variants");

        this.imageOpeners.forEach((wrapper) => {
          wrapper.classList.remove("active");
        });
        const selectedText = item.textContent.trim();
        const selectedValue = item.dataset.value;
        const imageUrl = item.dataset.image;
        const sliderMediaJson = item.dataset.sliderMedia;
        if (document.querySelector('.product__slider.embla')) {
          this.updateGallerySlider(sliderMediaJson);
        } else {
          const mediaUrl = item.dataset.media;
          const mediaType = item.dataset.mediaType;
          this.renderGalleryMedia(
            mediaUrl || item.dataset.image,
            mediaType,
            item.dataset.image,
          );
        }
        const price = item.dataset.price;
        const rawPrice = item.dataset.rawprice;
        const isAvailable = item.dataset.available;
        const variants = JSON.parse(item.dataset.variants || "[]");
        const variantVideos = JSON.parse(item.dataset.variantVideos || '{}');
        const compare = item.dataset.compare || '0';

        if (Array.isArray(variants) && variants.length) {
          group.innerHTML = "";
          group.classList.toggle("hidden", variants.length < 2);

          variants.forEach((variant, index) => {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.dataset.value = String(variant.id);
            btn.dataset.style = "green";
            btn.dataset.rawprice = String(variant.price);

            const formattedPrice = Shopify.formatMoney(
              variant.price,
              "{{ amount_no_decimals }}",
            );
            btn.dataset.price = "€" + formattedPrice;

            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              const formattedCompare = Shopify.formatMoney(variant.compare_at_price, "{{ amount_no_decimals }}");
              btn.dataset.compareAtPrice = "€" + formattedCompare;
              btn.dataset.rawCompareAtPrice = String(variant.compare_at_price);
            } else {
              btn.dataset.compareAtPrice = '';
              btn.dataset.rawCompareAtPrice = '0';
            }

            const videoUrl = variantVideos[String(variant.id)];
            btn.dataset.media = videoUrl || variant.featured_image?.src || '';
            btn.dataset.mediaType = videoUrl ? 'video' : 'image';
            btn.dataset.poster = variant.featured_image?.src || imageUrl || '';

            btn.className =
              `dropdown-variants__btn flex gap-8 g-btn g-btn--medium ` +
              (index === 0
                ? "g-btn--fill-tertiary-green"
                : "g-btn--outline-tertiary-green");

            const icon = document.createElement("div");
            icon.className = "dropdown-variants__icon";
            icon.innerHTML = `
              <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8047 0.195262C12.0651 0.455612 12.0651 0.877722 11.8047 1.13807L4.4714 8.4714C4.21106 8.73175 3.78894 8.73175 3.5286 8.4714L0.195262 5.13807C-0.0650874 4.87772 -0.0650874 4.45561 0.195262 4.19526C0.455612 3.93491 0.877722 3.93491 1.13807 4.19526L4 7.05719L10.8619 0.195262C11.1223 -0.0650874 11.5444 -0.0650874 11.8047 0.195262Z" fill="white"/>
              </svg>
            `;

            const title = document.createElement("span");
            title.textContent = variant.title;

            btn.appendChild(icon);
            btn.appendChild(title);

            group.appendChild(btn);
          });

          const groupButtons = Array.from(
            group.querySelectorAll("button[data-value]"),
          );
          this.handleBuyxGetyVariantChange(groupButtons, group, dropdown);
        }

        dropdown.classList.remove("buyx-gety__dropdown-oos");

        let imageWrapper = dropdown.querySelector(
          ".buyx-gety__dropdown-image img",
        );
        if (imageWrapper) {
          imageWrapper.src = imageUrl;
          imageWrapper.srcset = imageUrl;
        }

        dropdown.setAttribute("data-available", isAvailable);

        let priceWrapper = dropdown.querySelector(".plan-price");

        if (priceWrapper) {
          if (compare != "0") {
            priceWrapper.innerHTML = `<span class="original-price body-bold price__sale">${price}</span><span class="plan-price-wrapper body">${compare}</span>`;
          } else {
            priceWrapper.innerHTML = `<span class="original-price body-bold">${price}</span>`;
          }
        }
        if (rawPrice) {
          dropdown.dataset.currentPrice = rawPrice;
        }
        dropdown.dataset.compare = compare;
        dropdown.dataset.price = price;
        dropdown.dataset.rawCompare = item.dataset.rawCompare || '0';
        dropdown.dataset.selectedValue = selectedValue;

        sharedList.querySelectorAll(".buyx-gety__dropdown-item").forEach((el) => {
          el.classList.remove("dropdown-svg__visible");
        });
        item.classList.add("dropdown-svg__visible");

        if (label) label.textContent = selectedText;

        const parentLabel = dropdown.closest("label");

        const hiddenInput = parentLabel?.querySelector("input");
        let allDropdownsInLabel;

        if (hiddenInput) {
          const currentValue = hiddenInput.value;
          const variantIds = currentValue.split(",");

          allDropdownsInLabel = Array.from(
            parentLabel.querySelectorAll(".buyx-gety__dropdown"),
          );
          const dropdownIndex = allDropdownsInLabel.indexOf(dropdown);

          if (dropdownIndex >= 0 && dropdownIndex < variantIds.length) {
            variantIds[dropdownIndex] = selectedValue;
            hiddenInput.value = variantIds.join(",");
          }
        }

        dropdown.classList.remove("open");
        this.checkAvailabilities(allDropdownsInLabel);
      });
    }

    // Close all when clicking outside
    document.addEventListener("click", (e) => {
      this.imageOpeners.forEach((wrapper) => {
        wrapper.classList.remove("active");
      });
      dropdowns.forEach((dropdown) => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove("open");
        }
      });
    });
  }

  handleBuyxGetyVariantChange(buttons, group, dropdown) {
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.renderGalleryMedia(
          btn.dataset.media,
          btn.dataset.mediaType,
          btn.dataset.poster,
        );

        this.imageOpeners.forEach((wrapper) => {
        wrapper.classList.remove("active");
      });

        const btnStyle = btn.dataset.style;

        // 1) Toggle classes within this group
        if (btnStyle == "green") {
          buttons.forEach((b) => {
            b.classList.remove("g-btn--fill-tertiary-green");
            b.classList.add("g-btn--outline-tertiary-green");
          });
          btn.classList.add("g-btn--fill-tertiary-green");
          btn.classList.remove("g-btn--outline-tertiary-green");
        } else if (btnStyle == "purple") {
          buttons.forEach((b) => {
            b.classList.remove("g-btn--fill-secondary");
            b.classList.add("g-btn--outline-secondary");
          });
          btn.classList.add("g-btn--fill-secondary");
          btn.classList.remove("g-btn--outline-secondary");
        }

        // 2) Update price display and sync dataset
        const selectedValue = btn.dataset.value;
        const price = btn.dataset.price;
        const rawPrice = btn.dataset.rawprice;
        const compareAtPrice = btn.dataset.compareAtPrice || '';

        const planPriceEl = dropdown.querySelector(".plan-price");

        if (planPriceEl) {
          if (compareAtPrice) {
            planPriceEl.innerHTML = `<span class="original-price body-bold price__sale">${price}</span><span class="plan-price-wrapper body">${compareAtPrice}</span>`;
          } else {
            planPriceEl.innerHTML = `<span class="original-price body-bold">${price}</span>`;
          }
        }
        if (rawPrice) {
          dropdown.dataset.currentPrice = rawPrice;
        }
        dropdown.dataset.compare = compareAtPrice || '0';
        dropdown.dataset.price = price;
        dropdown.dataset.rawCompare = compareAtPrice ? (btn.dataset.rawCompareAtPrice || '0') : '0';

        const parentLabel = group.closest("label");
        const hiddenInput = parentLabel?.querySelector("input");
        let allDropdownsInLabel;

        if (hiddenInput) {
          allDropdownsInLabel = Array.from(
            parentLabel.querySelectorAll(".buyx-gety__dropdown"),
          );
          const currentValue = hiddenInput.value;
          const variantIds = currentValue.split(",");

          allDropdownsInLabel = Array.from(
            parentLabel.querySelectorAll(".buyx-gety__dropdown"),
          );
          const dropdownIndex = allDropdownsInLabel.indexOf(dropdown);

          if (dropdownIndex >= 0 && dropdownIndex < variantIds.length) {
            variantIds[dropdownIndex] = selectedValue;
            hiddenInput.value = variantIds.join(",");
          }
        }

        this.checkAvailabilities(allDropdownsInLabel);
      });
    });
  }

  checkAvailabilities(allDropdownsInLabel) {
    const allTrue = allDropdownsInLabel.every(
      (label) => label.dataset.available == "true",
    );

    if (allTrue) {
      this.buyxGetySubmit.disabled = false;
      this.handleDropdownSmallestPrices(allDropdownsInLabel);
    } else {
      this.buyxGetySubmit.disabled = true;
    }
    this.updateTotals();
  }

  updateTotals() {
    const totalsEl = this.querySelector('.buyx-gety__totals');
    if (!totalsEl) return;

    const totalSpan = totalsEl.querySelector('.buyx-gety__totals-total');
    const savedSpan = totalsEl.querySelector('.buyx-gety__totals-saved');
    if (!totalSpan || !savedSpan) return;

    if (!this._totalPrefix) {
      this._totalPrefix = totalSpan.textContent.split(': ')[0];
      this._savedPrefix = savedSpan.textContent.split(': ')[0];
    }

    const activeLabel = this.querySelector('.buyx-gety__label.buyx-gety__dropdown-variants-visible');
    if (!activeLabel) return;

    let totalRaw = 0;
    let savedRaw = 0;

    if (activeLabel.classList.contains('buyx-gety__label-default')) {
      const activeBtn = activeLabel.querySelector('.buyx-gety__default-variants .g-btn--fill-secondary');
      if (!activeBtn) return;
      totalRaw = parseInt(activeBtn.dataset.rawprice, 10) || 0;
      const rawCompare = parseInt(activeBtn.dataset.rawCompareAtPrice, 10) || 0;
      if (rawCompare > totalRaw) savedRaw = rawCompare - totalRaw;
    } else {
      const dropdowns = Array.from(activeLabel.querySelectorAll('.buyx-gety__dropdown'));
      if (!dropdowns.length) return;

      const prices = dropdowns.map(d => ({
        raw: parseInt(d.dataset.currentPrice, 10) || 0,
        rawCompare: parseInt(d.dataset.rawCompare, 10) || 0,
      }));

      const count = prices.length === 3 ? 1 : prices.length === 6 ? 2 : prices.length === 10 ? 4 : 0;
      const freeSet = new Set(
        prices
          .map((p, i) => ({ value: p.raw, index: i }))
          .sort((a, b) => a.value - b.value)
          .slice(0, count)
          .map(p => p.index)
      );

      prices.forEach((p, i) => {
        if (freeSet.has(i)) {
          savedRaw += (p.rawCompare > p.raw) ? p.rawCompare : p.raw;
        } else {
          totalRaw += p.raw;
          if (p.rawCompare > p.raw) savedRaw += p.rawCompare - p.raw;
        }
      });
    }

    const fmt = (raw) => '€' + Shopify.formatMoney(raw, '{{ amount_no_decimals }}');
    totalSpan.textContent = this._totalPrefix + ': ' + fmt(totalRaw);

    if (savedRaw > 0) {
      savedSpan.textContent = this._savedPrefix + ': ' + fmt(savedRaw);
      savedSpan.style.display = '';
    } else {
      savedSpan.style.display = 'none';
    }
  }

  handleDropdownSmallestPrices(allDropdownsInLabel) {
    const prices = allDropdownsInLabel.map((el, i) => ({
      value: Number(el.dataset.currentPrice),
      index: i,
    }));

    const count =
      prices.length === 3
        ? 1
        : prices.length === 6
          ? 2
          : prices.length === 10
            ? 4
            : 0;

    const smallestIdxSet = new Set(
      prices
        .slice()
        .sort((a, b) => a.value - b.value)
        .slice(0, count)
        .map((p) => p.index),
    );

    // change price elements
    allDropdownsInLabel.forEach((wrapEl, idx) => {
      const gratis = wrapEl.dataset.gratis || '0';
      const compare = wrapEl.dataset.compare || '0';
      const currentPrice = wrapEl.dataset.price || '';
      const planPriceEl = wrapEl.querySelector(".plan-price");

      if (!planPriceEl || !currentPrice) return;

      const hasCompare = compare !== '0' && compare !== '';

      if (smallestIdxSet.has(idx)) {
        const strikePrice = hasCompare ? compare : currentPrice;
        planPriceEl.innerHTML = `${gratis} <span class="original-price body">${strikePrice}</span>`;
      } else {
        if (hasCompare) {
          planPriceEl.innerHTML = `<span class="original-price body-bold price__sale">${currentPrice}</span><span class="plan-price-wrapper body">${compare}</span>`;
        } else {
          planPriceEl.innerHTML = `<span class="original-price body-bold">${currentPrice}</span>`;
        }
      }
    });
  }

  handleVariantChange(event) {
    const variantId = event.target.value;
    const variantTitle = event.target.dataset.title;
    const stock = event.target.dataset.stock;
    const variantPrice = event.target.dataset.price;
    const variantComparePrice = event.target.dataset.comparePrice;
    const currency = event.target.dataset.currency;
    const variantVideo = event.target.dataset.video;

    this.handleStockAmount(stock);
    this.handlePrices(variantPrice, variantComparePrice, currency);
    this.updateURLWithVariant(variantId);

    this.variantInputs.forEach((i) => {
      i.closest("label")?.classList.remove("product-form__label-checked");
    });
    event.target.closest("label")?.classList.add("product-form__label-checked");

    if (variantTitle) {
      this.variantTitle.textContent = variantTitle;
    }

    this.renderGalleryMedia(
      event.target.dataset.media,
      event.target.dataset.mediaType,
      event.target.dataset.poster,
    );
  }

  handleQuantityChange(event) {
    // the input you clicked
    const clickedInput = event.target.closest(
      'input[type="radio"][name="quantity"]',
    );
    if (!clickedInput) return;

    // for each radio, get its <label> too
    this.quantityInputs.forEach((input) => {
      const currentLabel = this.getLabelForInput(input);
      let currentLabelBadgesDiv = currentLabel.querySelector(
        ".product-form__labels",
      );

      if (currentLabelBadgesDiv) {
        currentLabelBadgesDiv.querySelectorAll("div").forEach((badge) => {
          badge.style.backgroundColor = "var(--body-base)";
        });
      }
    });

    const clickedLabel = this.getLabelForInput(clickedInput);
    let clickedLabelBadgesDiv = clickedLabel.querySelector(
      ".product-form__labels",
    );

    if (clickedLabelBadgesDiv) {
      clickedLabelBadgesDiv.querySelectorAll("div").forEach((badge) => {
        let border = badge.dataset.border;
        let back = badge.dataset.back;
        badge.style.backgroundColor = back;
        badge.style.border = "1px solid " + border;
      });
    }
  }

  // helper: find the label associated with an input (wrapped label or label[for=id])
  getLabelForInput(input) {
    if (input.labels && input.labels.length) return input.labels[0];
    if (input.id) {
      const byFor =
        this.querySelector(`label[for="${input.id}"]`) ||
        document.querySelector(`label[for="${input.id}"]`);
      if (byFor) return byFor;
    }
    return input.closest("label") || null;
  }

  handleStockAmount(stock) {
    if (this.productStockBlock) {
      const stockFigure = this.productStockBlock.querySelector(
        ".product__stock-figure",
      );
      const stockSpan = this.productStockBlock.querySelector(
        ".product__stock-text",
      );

      let lowstockText = this.productStockBlock.dataset.lowstockText;
      const lowstockColor = this.productStockBlock.dataset.lowstockColor;

      const oosText = this.productStockBlock.dataset.oosText;
      const oosColor = this.productStockBlock.dataset.oosColor;

      const availableText = this.productStockBlock.dataset.onstockText;
      const availableColor = this.productStockBlock.dataset.onstockColor;

      switch (true) {
        case stock == 0:
          if (oosText && oosColor) {
            stockSpan.textContent = oosText;
            stockFigure.style.backgroundColor = oosColor;
          }
          break;

        case stock < 10:
          if (lowstockText && lowstockColor) {
            lowstockText = lowstockText.replace("[---]", stock);
            stockSpan.textContent = lowstockText;
            stockFigure.style.backgroundColor = lowstockColor;
          }
          break;

        default:
          if (availableText && availableColor) {
            stockSpan.textContent = availableText;
            stockFigure.style.backgroundColor = availableColor;
          }
      }
    }
  }

  handlePrices(price, comparePrice, currency) {
    if (!price || comparePrice) return;

    if (this.quantityLabel1) {
      let priceElement = this.quantityLabel1.querySelector(".plan-price");
      if (priceElement) {
        if (price) {
          priceElement.textContent = currency + price / 100.0;
        }
        if (comparePrice) {
          let comparePriceElement = document.createElement("span");
          comparePriceElement.classList.add("original-price", "body");
          comparePriceElement.textContent = comparePrice;
          priceElement.appendChild(comparePriceElement);
        }
      }
    }

    if (this.quantityLabel3) {
      let priceElement = this.quantityLabel2.querySelector(".plan-price");
      if (priceElement) {
        if (price) {
          let discountedPrice = (price * 2 * 0.9) / 100.0;
          priceElement.textContent = currency + discountedPrice.toFixed(2);

          let comparePriceElement = document.createElement("span");
          comparePriceElement.classList.add("original-price", "body");
          comparePriceElement.textContent = currency + (price * 2) / 100;
          priceElement.appendChild(comparePriceElement);
        }
      }
    }

    if (this.quantityLabel3) {
      let priceElement = this.quantityLabel3.querySelector(".plan-price");
      if (priceElement) {
        if (price) {
          let discountedPrice = (price * 3 * 0.8) / 100.0;
          priceElement.textContent = currency + discountedPrice.toFixed(2);

          let comparePriceElement = document.createElement("span");
          comparePriceElement.classList.add("original-price", "body");
          comparePriceElement.textContent = currency + (price * 3) / 100;
          priceElement.appendChild(comparePriceElement);
        }
      }
    }
  }

  sortDropdownItems() {
    document
      .querySelectorAll(".buyx-gety__dropdown-list-elements2")
      .forEach((list) => {
        const items = Array.from(
          list.querySelectorAll(".buyx-gety__dropdown-item"),
        );
        if (!items.length) return;

        const main = items.find((i) => i.dataset.mainProduct);
        if (!main) return;

        const getNum = (el) => {
          const title = (
            el.dataset.mainProduct ||
            el.dataset.restProduct ||
            ""
          ).trim();
          const m = title.match(/^(\d+)\s*[x×]/i);
          return m ? parseInt(m[1], 10) : 0;
        };

        const currentNum = getNum(main);

        const groups = {};
        items.forEach((item) => {
          const n = getNum(item);
          if (!groups[n]) groups[n] = [];
          groups[n].push(item);
        });

        const numbers = Object.keys(groups).map(Number);
        const higher = numbers
          .filter((n) => n > currentNum)
          .sort((a, b) => a - b);
        const lower = numbers
          .filter((n) => n < currentNum)
          .sort((a, b) => b - a);
        const order = [currentNum, ...higher, ...lower];

        const sorted = [];
        order.forEach((n) => {
          if (groups[n]) groups[n].forEach((item) => sorted.push(item));
        });

        //
        list.innerHTML = "";
        sorted.forEach((el) => list.appendChild(el));
      });
  }
}

customElements.define("main-product", MainProduct);
